/**
 *  10원 단위 체크
 */
export const REX_TEN_WON_UNIT = /^0|(-?[1-9]+([0-9,?]+)?0)$/;

/**
 *  100 단위 체크
 */
export const REX_ONE_HUNDRED_UNIT = /^0|(-?[1-9]+([0-9,?]+)?00)$/;

/**
 *  URL 패턴 체크
 */
export const REX_URL =
  /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z가-힣0-9()@:%_+.~#?&//=,]*)$/;

/**
 *  기획전에 포함되는 링크는 URL 또는 amondz:// 앱스키마를 포함
 */
export const REX_URL_AND_APP_SCHEME = /^(https?|amondz)?:\/\/(www\.)?.+$/;

/**
 *  인스타그램 URL 패턴 체크
 */
export const REX_INSTAGRAM_URL = /^(https):\/\/(?:www\.)?(?:instagram\.com|instagr\.am)\/([A-Za-z0-9-_\\.]+)\/?$/;

/**
 *  인스타그램 URL 패턴 체크
 */
export const REX_YOUTUBE_OR_VIMEO_URL =
  /^((?:https?:)?\/\/)?((?:www|m|player)\.)?((?:youtube\.com|youtu.be|vimeo\.com))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;

/**
 *  숫자의 천 단위마다 특정 텍스트를 붙여주는 패턴
 */
export const REX_ADD_TEXT_FOR_NUMBER = /\B(?=(\d{3})+(?!\d))/g;

/**
 *  이름 패턴
 */
export const REX_NAME = /^[A-Za-z0-9가-힣]{2,15}$/;

/**
 * 유저 이름 패턴
 */
export const REX_USER_NAME = /^[A-Za-z0-9가-힣\s]{1,20}$/;

/**
 *  친구초대 코드 패턴
 */
export const REX_INVITE_FRIEND_CODE = /^[A-Za-z0-9가-힣]{2,15}$/;

/**
 *  예금주 패턴 (괄호를 포함한 이름)
 */
export const REX_ACCOUNT_HOLDER = /^[A-Za-z0-9가-힣\s(),.!]{2,50}$/;

/**
 *  예금주 패턴 (괄호를 제외한 이름)
 */
export const REX_ACCOUNT_HOLDER_EXCEPT_BRACKET = /^[A-Za-z0-9가-힣\s(),.!]{1,50}$/;

/**
 *  핸드폰 번호 패턴
 */
export const REX_PHONE = /^010-?([0-9]{3,4})-?([0-9]{4})$/;

/**
 *  유선 전화번호 패턴
 */
export const REX_EXTRA_PHONE =
  /^((0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]|70))-?([0-9]{3,4})-?([0-9]{4}))$|^(1588|1577|1899|1544|1644|1661|1566|1600|1670|1688|1666|1599|1877|1855|1800)-?([0-9]{4,4})$|^(050?([0-9]{1})-?([0-9]{4})-?([0-9]{4}))$/;

/**
 *  대표 전화번호 패턴
 */
export const REX_GENERAL_PHONE =
  /^(010-?([0-9]{4})-?([0-9]{4}))$|^(((0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]|70))-?([0-9]{3,4})-?([0-9]{4})))$|^(1588|1577|1899|1544|1644|1661|1566|1600|1670|1688|1666|1599|1877|1855|1800)-?([0-9]{4,4})$|^(050?([0-9]{1})-?([0-9]{4})-?([0-9]{4}))$/;

/**
 *  숫자만 들어가게 하는 패턴
 */
export const REX_NUMBER = /^[0-9]*$/;

/**
 *  숫자외 패턴
 */
export const REX_EXCEPT_NUMBER = /[^0-9]/g;

/**
 *  영문명 패턴 (영문, 공백, 숫자, 특수문자)
 */
export const REX_ENG_NAME = /^[a-zA-Z0-9\s+{}[\]/?.,;:|)*~`!^\-_+<>@#$%&\\=('"]+$/;

/**
 *  사업자 등록번호 패턴
 */
export const REX_BUSINESS_LICENSE = /^([0-9]{3})-?([0-9]{2})-?([0-9]{5})$/;

/**
 *  통신판매업 신고번호 패턴
 */
export const REX_ONLINE_SALES_REG = /^[0-9가-힣-]{12,20}$/;

/**
 *  비밀번호 패턴(영문, 숫자, 특수문자)
 */
export const REX_ADMIN_PASSWORD_REG =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@#$%^&*()_\-+=[\]{}|\\;:'"<>,.?/₩])[A-Za-z\d~!@#$%^&*()_\-+=[\]{}|\\;:'"<>,.?/₩]{6,20}$/;

/**
 *  마일스톤 패턴
 */
export const REX_MILESTONE = /^M[0-9]{1,4}$/;

/**
 *  스프린트 패턴
 */
export const REX_SPRINT = /^S[0-9]{1,4}$/;

/**
 *  서비스 버전 패턴
 * [0~9999] . [0~9999] . [0~9999] . [0~9999] ......
 */
export const REX_SERVICE_VERSION = /^(?:(?:[0-9]?[0-9]?[0-9]?[0-9])\.)*(?:[0-9]?[0-9]?[0-9]?[0-9])$/;

/**
 * 버전 패턴
 */
export const REX_VERSION = /^[0-9]{1,10}$/;

/**
 *  쿠폰 코드 패턴
 */
export const REX_COUPON_CODE = /^[a-z0-9가-힣]{0,30}$/;

/**
 *  한글, 영어, 숫자, 띄워쓰기만 허용하는 패턴
 */
export const REX_KOR_ENG_NUM_SPACE_ALLOW = /^[ㄱ-ㅎ가-하가-힣a-zA-Z0-9\s]$/;

/**
 *  A/S 전화번호 패턴
 */
export const REX_ASPHOHE_NUMBER =
  /^(050?([0-9]{1})-?([0-9]{4})-?([0-9]{4}))$|^(010-?([0-9]{4})-?([0-9]{4}))$|(((0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]|70))-?([0-9]{3,4})-?([0-9]{4})))$|(1588|1577|1899|1544|1644|1661|1566|1600|1670|1688|1666|1599|1877|1855|1800)-?([0-9]{4,4})$/;

/**
 *  생년월일 패턴(년, 원, 일 사용)
 */
export const REX_BIRTHDAY = /^(19[0-9][0-9]|20\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;

/**
 * 환불 계좌 번호 패턴
 */
export const REX_ACCOUNT_NUMBER = /^[0-9]{1,50}$/;

/**
 * 카테고리 명 패턴(한글, 영어 ,숫자, 특수문자, 띄워쓰기)
 * @type {RegExp}
 */
export const REX_CATEGORY_NAME = /^[a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣0-9\s{}[\]/?.,;:|)*~`!-_+<>@#$%&\\=('"]+$/;

//영어,한글,숫자,특수문자 아닌 문자 패턴
export const REX_NOT_TEXT = /[^a-zA-Zㄱ-ㅎ가-힣0-9\s{}[\]/?.,;:|)*~`!-_+<>@#$%&\\=('"]+$/;

/**
 * 카테고리 서브 텍스트 패턴(한글, 영어, 숫자, 띄워쓰기)
 * @type {RegExp}
 */
export const REX_CATEGORY_SUB_TEXT = /^[a-z0-9가-힣\s]{0,20}$/;

/**
 *  한글, 영문 대소문자, 숫자를 허용하며, 특수기호는 허용하지 않음.
 */
export const REX_USER_NAME_TEXT = /^[가-힣a-zA-Z\s\d]{2,20}$/;
/**
 *  이메일 정규식
 */
export const REX_USER_EMAIL_PATTERN = /^[A-Za-z0-9._-]{2,}@[A-Za-z0-9.-]+?\.[A-Za-z]{2,}$/;

/**
 * 색상 헥사 코드
 */
export const REX_COLOR_HEXA_CODE = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
